import { RouteObject } from "react-router-dom";
import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router";
import { ApiClient, isErrorResponse, ApiError } from "botloader-common";
import { CreateFetcher } from "../../Util";
import { BuildConfig } from "../../BuildConfig";

export const routes: RouteObject[] = [
    {
        index: true,
        element: <ConfirmLoginPage />
    }
]


interface LoadingStatus {
    loading: boolean,
    error?: ApiError,
}

export function ConfirmLoginPage() {
    const confirmingLogin = useRef(false)
    let [status, setStatus] = useState<LoadingStatus>({
        loading: true,
    });

    let loc = useLocation();

    useEffect(() => {
        let query = new URLSearchParams(loc.search);

        async function completeLogin() {
            let client = new ApiClient(CreateFetcher(), BuildConfig.botloaderApiBase);
            let resp = await client.confirmLogin(query.get("code") as string, query.get("state") as string)
            if (!isErrorResponse(resp)) {
                localStorage.setItem("botloader_token", resp.token);
                setStatus({
                    loading: false,
                });
            } else {
                setStatus({
                    loading: false,
                    error: resp,
                });
            }
        }

        // in react strict mode this hook triggers twice, 
        // causing the csrf token to expire and the login the be invalidated
        if (confirmingLogin.current) {
            return
        }
        confirmingLogin.current = true

        completeLogin()

    }, [loc])

    if (status.loading) {
        return <h2>Logging you in...</h2>
    } else {
        if (status.error) {
            return <p>Failed logging you in: <code>{JSON.stringify(status.error)}</code></p>
        } else {
            window.location.href = window.location.origin + "/servers";
            return <p>Redirecing you...</p>
        }
    }
}